define('extensions/uv-ebook-extension/Events',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Events = /** @class */ (function () {
        function Events() {
        }
        Events.namespace = "ebookExtension.";
        Events.CFI_FRAGMENT_CHANGED = Events.namespace + "cfiFragmentChanged";
        Events.ITEM_CLICKED = Events.namespace + "itemClicked";
        Events.LOADED_NAVIGATION = Events.namespace + "loadedNavigation";
        Events.RELOCATED = Events.namespace + "relocated";
        Events.RENDITION_ATTACHED = Events.namespace + "renditionAttached";
        Events.TOC_READY = Events.namespace + "tocReady";
        return Events;
    }());
    exports.Events = Events;
});

